import {Button, Divider, Stack} from '@mui/material';
import React, {useCallback, useState} from 'react';

import {ChatRoomsEnum, GuidesEnum} from 'presentation/constants';
import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {useCallChatRoom, useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {useNavigate} from 'react-router-dom';
import {NotFoundDialog} from '../NotFoundDialog';
import {NotFoundListCardProps} from './types';

const {orientationCard} = translations['pt-br'].privateFlow.profile.locationSelection;

export function NotFoundListCardAction({
	customOrientationText,
	variant,
	flowType,
	children,
	pathGoTo,
}: NotFoundListCardProps) {
	const {isMobile} = useMediaQueries();
	const navigate = useNavigate();

	const [notFoundModalIsOpen, setNotFoundModalIsOpen] = useState(false);

	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();

	const handleCallChatRoom = useCallback(async (flowTypeEnum?: FlowEnum) => {
		let type = ChatRoomsEnum.APP;

		if (flowTypeEnum === FlowEnum.ODONTO) {
			type = ChatRoomsEnum.ODONTO;
		}

		await callChatRoom(type);
		setNotFoundModalIsOpen(false);
	}, [callChatRoom]);

	const handleGuideNav = () => {
		navigate(pathGoTo ?? GuidesEnum.SERVICE_NETWORK_HEALTH);
		setNotFoundModalIsOpen(false);
	};

	function handleOpenModal() {
		setNotFoundModalIsOpen(true);
	}

	return (
		<Stack gap={2}>
			<Divider />
			<Stack
				alignItems={'end'}
				direction={children ? 'row' : 'column'}
				justifyContent={'space-between'}>
				<Button
					variant="outlined"
					fullWidth={isMobile}
					size="large"
					onClick={handleOpenModal}>
					{customOrientationText ?? orientationCard}
				</Button>
				{children}
			</Stack>
			<NotFoundDialog
				variant={variant}
				handleCallChatRoom={async () =>
					handleCallChatRoom(
						flowType === FlowEnum.ODONTO
							? FlowEnum.ODONTO_GUIDE
							: FlowEnum.HEALTH_GUIDE,
					)
				}
				isDisabled={callChatRoomIsLoading}
				isLoading={callChatRoomIsLoading}
				handleGuideNav={() => handleGuideNav()}
				open={notFoundModalIsOpen}
				setOpen={setNotFoundModalIsOpen}
			/>
		</Stack>
	);
}
